import useAuth from "./useAuth";
import { axiosPrivateInstance } from "../axios";

export default function useLogout() {
  const { setUser, setAccessToken, setCSRFToken } = useAuth();

  const logout = async () => {
    await axiosPrivateInstance.post("auth/logout/");

    setAccessToken(null);
    setCSRFToken(null);
    setUser(null);
    document.cookie = "access=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "refresh=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.setItem("isLoggedOut", "true");
    localStorage.removeItem("hasSession");
  };

  return logout;
}
